export const initialState = {
  DB: {}
};
